module.exports = __webpack_public_path__ + "img/proname.e771ba18.svg";